import React from "react";
import gql from 'graphql-tag';
import CompanyNewsComponent from "../NewComponent/News";
import LayoutMain from "../../../Elements/LayoutMain/LayoutMain";
import QueryNewsAll from "./QueryNewsAll/QueryNewsAll";



function GatsbyNewsSource (props) {
    function TextSource(info) {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}

    return (
            <LayoutMain title={props.title} description={props.description} lang={props.lang} AllMenu={['ElementMenuActive','','','','','']} Active={0}>
                <main className="StandartPage CompanyNews">
                    <div className="StandartTitle NewsTitle"><TextSource ArrIndex= 'News0010'>News</TextSource></div>
                    <QueryNewsAll lang={props.lang}/>
                </main>
            </LayoutMain>
        )}

export default GatsbyNewsSource
